const state = {
  bots: '',
};

export default state;
